import axios from 'axios';


export const getEvents = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`events`);
};
export const getTheEvent = (id:number) => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`events/one?id=`+id);
};
export const AddEvent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`events/create`, obj, {
    headers,
  });
};

export const EditEvent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`events/update`, obj, {
    headers,
  });
};

export const DeleteEvent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`events/delete`, obj, {
    headers,
  });
};
